module.exports = __webpack_public_path__ + "static/meta-images-e5c9ddde61a2481a1662d21656b5aa8f.jpg";